export default __webpack_public_path__ + "static/media/brussels-sprouts-pancetta-haloumi-fritters-solanato-qukes.f7ca1409.png";